exports = module.exports = require("../../../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-message p {\n  text-align: center;\n  padding: 10px;\n  background-color: #dc3545;\n  margin: 0;\n  font-size: 18px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Magento2/gs-kiosk/src/app/routes/login/login.component.scss
// module id = ../../../../../src/app/routes/login/login.component.scss
// module chunks = main